module.exports = "/images/lifestyle-change.png?11a2d5e536780ce1f9531122adb96088";